import React, { FunctionComponent, useContext } from 'react';
import styles from './HeaderBottom.module.scss';
import { WPMenu } from 'types/menus';
import { ReactComponent as LogoDesktop } from './logoDesktop.svg';
import { HeaderBottomItem } from 'components/presentional';
import { LinkWrapper } from 'components/elements';
import { LanguageContext } from 'context';

interface OwnProps {
  menu?: WPMenu | null;
}

type HeaderBottomProps = JSX.IntrinsicElements['div'] & OwnProps;

const languageUrls = {
  de: 'https://testarmy.de',
  en: 'https://testarmy.com',
  pl: 'https://testarmy.com/pl',
  fr: 'https://testarmy.fr',
};

const HeaderBottom: FunctionComponent<HeaderBottomProps> = props => {
  const { menu } = props;
  const { items = [] } = menu || {};
  const { language } = useContext(LanguageContext);
  const href = languageUrls[language] || languageUrls.en; // Default to English if language is not found

  return (
    <div className={styles.wrapper}>
      <div role="navigation" aria-label="Desktop bottom menu" className={styles.container}>
        <LinkWrapper href={href} className={styles.logo} aria-label="TestArmy logo">
          <LogoDesktop />
        </LinkWrapper>
        {items.map(item => (
          <HeaderBottomItem key={`header-bottom-item-${item.ID}`} item={item} />
        ))}
      </div>
    </div>
  );
};

export default HeaderBottom;
